import { Dispatch, SetStateAction } from 'react';
import { COUNTRY } from '@mango-engineering/maknet-client-sdk/lib/shop/types';
import { config } from '../../config/env';
import { HomeRecommendationRequest, RecommendationPayload, RecommendationResponse, RecommendationType } from '../../types/common';
import { Product } from '../../types/product.types';
import { PRODUCT_PAGE_SIZE } from '../../utils/constants';
import { getRecommendationPieceResultV2, getVariant } from '../../utils/helper';
import RecommendationErrorHandler from '../Error/RecommendationErrorHandler';
import ProductService from '../product/product.service';
import RecommendationServices from '../recommendation/recommendations.service';

export async function homeRecommendationProducts(
  payload: RecommendationPayload,
  setIsLoading?: Dispatch<SetStateAction<boolean>>,
  setIsProductApiLoading?: Dispatch<SetStateAction<boolean>>,
  assignRecommendationData?: (rProducts: RecommendationResponse) => RecommendationResponse,
  isPromoTagV2Enabled?: boolean,
  mmid?: string,
  isNative?: boolean,
): Promise<RecommendationResponse> {
  const topPickDiversifyResults = payload?.diversifyResults;
  const isUnifiedBasketEnabled = config.SHOPPING_ENABLE_UNIFIED_BASKET && isNative;
  const isStoreCodesForRecommendationEnabled = config.ENABLE_STORE_CODES_FOR_RECOMMENDATIONS;
  const requestPayload = {
    page: payload.page || 1,
    size: PRODUCT_PAGE_SIZE,
    diversifyResults: topPickDiversifyResults,
    countryCode: payload?.countryCode,
  } as HomeRecommendationRequest;
  const data = await RecommendationServices.getHomeRecommendationProducts(
    requestPayload,
    payload?.accessToken ?? '',
    getVariant(payload?.type) ?? '',
    payload?.userId ?? '',
    payload?.recommendationStoreCodes ?? payload?.storeCodes,
    payload?.type,
    payload?.appMode,
    payload?.type === RecommendationType.BASKET_RECOMMENDATION ? isStoreCodesForRecommendationEnabled : false,
  );

  assignRecommendationData?.(data as unknown as RecommendationResponse);
  setIsLoading?.(false);

  const productIds = data?.products?.map((x) => x.id);

  setIsProductApiLoading?.(true);

  const brandProductsData = await ProductService.getProductsByIdsV2(
    productIds,
    payload?.storeCodes ?? [],
    payload?.isExpressMode,
    payload?.isSameDay,
    undefined,
    payload?.expressStoreCodes,
    payload?.countryCode as COUNTRY | undefined,
    isPromoTagV2Enabled,
    mmid,
    payload?.afcStoreCodes,
    payload?.isAfcStoreEnabled,
    payload?.userSegments,
    payload?.isHorecaMemberEnabled,
  );

  const bproducts = getRecommendationPieceResultV2(
    data.products,
    brandProductsData as Product[],
    payload?.recommendationStoreCodes ?? payload?.storeCodes ?? [],
    isUnifiedBasketEnabled ? undefined : (payload?.isExpressMode ?? false),
    payload?.hasAlcoholProductAvailability,
  ) as Product[];

  setIsProductApiLoading?.(false);

  if (productIds?.length !== 0)
    return {
      products: bproducts || [],
      recommendationType: data.recommendationType,
      totalCount: data.totalCount,
      actualCount: productIds?.length,
      algorithm: data?.algorithm,
      personalised: data?.personalised,
    };
  else {
    return RecommendationErrorHandler.getDefaultErrorResponse();
  }
}
